import Modal from "@common/Modal";
import ClockLogo from "../../../styles/webroot/images/clock.gif"
import { useState,useEffect } from 'react'
import moment from "moment";
import { toast } from "react-toastify";
import { WHATSAPP_WEB_URL } from "@src/config/id/constant";
import { isMobile } from "react-device-detect";
import { useLanguage } from "@src/context/LanguageContext";

interface PaymentUrlPopupProps {
  show: boolean;
  handleClose: () => void;
  paymentUrl: string;
  onRefresh: () => void;
  expiryDate: string;
}

export default function PaymentUrlPopup({
  show,
  handleClose,
  paymentUrl,
  onRefresh,
  expiryDate
}: PaymentUrlPopupProps) {

    const [timeLeft, setTimeLeft] = useState("");
    const {translations} = useLanguage();

    useEffect(() => {
        if (!expiryDate) return;

        const interval = setInterval(() => {
            const now = moment();
            const expiry = moment(expiryDate);

            const duration = moment.duration(expiry.diff(now));

            if (duration.asMilliseconds() <= 0) {
            setTimeLeft("00D : 00H : 00M : 00S");
            clearInterval(interval);
            return;
            }

            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            setTimeLeft(
            `${String(days).padStart(2, "0")}D : ${String(hours).padStart(2, "0")}H : ${String(minutes).padStart(2, "0")}M : ${String(seconds).padStart(2, "0")}S`
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [expiryDate]);

    const handleCopy = () => {
        navigator.clipboard.writeText(paymentUrl);
        toast.success(translations?.GENERATE_PAYMENT?.PAYMENT_LINK_COPIED);
    };

    const handleShare = async () => {
        if (navigator.share) {
            await navigator.share({
                title: "Payment Link",
                text: "Here is your payment link",
                url: paymentUrl,
            });
        } else {
            toast.info("Sharing not supported in this browser");
        }
    };

    const handleWhatsappShare = () => {
        let url:string = WHATSAPP_WEB_URL
        if(isMobile) url = 'https://wa.me/?text='
        const formattedExpiry = expiryDate ? moment(expiryDate).format("D MMM, YYYY") : "";
        const message = `Thank you for trusting Zen Insure.ID's partners as your insurance solution!\n\nTo proceed, please complete your payment before ${formattedExpiry}\n\n🔗 ${paymentUrl}`;
        const whatsappUrl = `${url}${encodeURIComponent(message)}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <div className="payment-link-popup-wrapper">
        <Modal show={show} handleClose={handleClose}>
            <div className="plp-modal">

            {/* Icon */}
            <div className="plp-icon">
                <img src={ClockLogo} alt="Timer" />
            </div>

            {/* Timer */}
            <p className="plp-timer">{timeLeft}</p>

            {/* Title */}
            <h2 className="plp-title">{translations?.GENERATE_PAYMENT?.PAYMENT_LINK_GENERATED}</h2>

            {/* URL */}
            <a href={paymentUrl} className="plp-url" target="_blank">
                {paymentUrl}
            </a>

            {/* Actions */}
            <div className="plp-actions">
                <button className="plp-btn icon" onClick={handleCopy}><i className="ic-content_copy m-sm-l" ></i></button>
                <button className="plp-btn icon" onClick={handleShare}><i className="ic-share"></i></button>
                <button className="plp-btn whatsapp" onClick={handleWhatsappShare}>
                <i className="ic-whatsapp"></i>
                {translations?.GENERATE_PAYMENT?.SHARE_ON_WHATSAPP}
                </button>
            </div>

            {/* Refresh */}
            {/* <button className="plp-refresh" onClick={onRefresh}>
                ⟳ Refresh
            </button> */}

            {/* Warning */}
            <div className="plp-warning">
                <i className="ic-warning"></i>
                <span>
                {translations?.GENERATE_PAYMENT?.PARAGRAPH_1}
                </span>
            </div>

            </div>
        </Modal>
        </div>
    );
}
